import * as yup from 'yup';

export const createCustomSubscriptionSchema = yup.object().shape({
  email: yup.string().email('El email debe ser válido').required('El email es requerido'),

  user: yup.string().required('El usuario es requerido'),

  periodStartDate: yup.string().nullable(),

  periodEndDate: yup.string().nullable(),

  plan: yup.string().required('El plan es requerido'),

  paymentMethod: yup.string().required('El método de pago es requerido'),

  transactionId: yup.string().nullable(),

  notes: yup.string().nullable(),
});

export const updateCustomSubscriptionSchema = yup.object().shape({
  periodStartDate: yup.string().required('El periodo de inicio es requerido'),

  periodEndDate: yup.string().required('El periodo de fin es requerido'),

  status: yup.string().required('El estado es requerido'),

  plan: yup.string().required('El plan es requerido'),

  paymentMethod: yup.string().required('El método de pago es requerido'),

  transactionId: yup.string().nullable(),

  notes: yup.string().nullable(),
});
